import React from 'react';
import useGuardedFunction from 'Hooks/useGuardedFunction';

/**
 * useMountedGuard
 *
 * Provides an interface for running functions if a component is mounted.
 * Hooks are guaranteed to run in order, so specific functionality related to mounting of a component can be written/run within the calling component.
 */
export default function useMountedGuard() {
  const {
    guardFunction, setGuardFailing, setGuardPassing, isPassingGuard,
  } = useGuardedFunction();

  React.useEffect(() => {
    setGuardPassing();

    return () => {
      setGuardFailing();
    };
  }, []);

  return {
    isMounted: isPassingGuard,
    doWithMountedGuard: guardFunction,
  };
}
